// extracted by mini-css-extract-plugin
module.exports = {"btn":"ExpandGroup_btn__3t9Eb","expanded":"ExpandGroup_expanded__1SKuq"};